export default "__VITE_ASSET__5148dc7d__"